export default __webpack_public_path__ + "static/media/ktp-01.27d38116.png";